import React from "react";
import TariffOrder from "./Containers";
import { sendMetriks } from "Services/sendMetriks";

const TariffOrderPopup = (props) => {
	const tariff = props.tariff;

	const onClickHandler = () => {
		let modalModel = props.modalModel;
		let promise1 = import("Layouts/modalLayout");
		promise1.then((modules) => {
			let ModalLayout = modules.default;
			modalModel.toggleModal(
				<ModalLayout
					closeModal={closeModal}
					fullCloseElement={true}
					onlyDesktopCloseElement={true}
					closeOnClickLayout={false}
					popupB={true}
					withoutClose
				>
					<TariffOrder
						modalModel={modalModel}
						tariff={tariff}
						closeModal={closeModal}
						closeModalPoPup={closeModal}
						providerInfo={props.providerInfo}
						connectURL={props.connectURL}
						buttonFrame={props.buttonFrame}
						frame={props.frame}
					/>
				</ModalLayout>
			);
		});
	};

	const closeModal = () => {
		let modalModel = props.modalModel;
		modalModel.toggleModal();
		sendMetriks("POP_UP_OPERATOR_CLOSED");
	};

	let children = React.cloneElement(props.children, {
		onClick: () => {
			props.onClick();
			onClickHandler();
		},
	});
	return children;
};

export default TariffOrderPopup;
